import { Injectable } from '@angular/core';
import { JSEncrypt } from 'jsencrypt';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JsencryptService {

  private pubKey: string;
  private privKey: string;

  constructor() {
    this.pubKey = environment.jsencrypt.Code_Pub;
    this.privKey = environment.jsencrypt.Code_Priv;
  }

  get JSEncrypt() {
    return JSEncrypt;
  }

  get getPubKey(): string {
    return this.pubKey;
  }

  get getPrivKey(): string {
    return this.privKey;
  }

  encrypt(data: any): string | any {
    if (data === undefined || data === null) { return data; }
    const encrypt = new this.JSEncrypt({});
    encrypt.setPublicKey(this.pubKey);
    let encrypted = encrypt.encrypt(data);
    return encrypted;
  }

  decrypt(data: any): string | any {
    if (data === undefined || data === null) { return data; }
    const decrypt = new JSEncrypt({});
    decrypt.setPrivateKey(this.privKey);
    const uncrypted = decrypt.decrypt(data);
    return uncrypted;
  }

}
